import { render, staticRenderFns } from "./CampusList.vue?vue&type=template&id=1b5cc294&scoped=true"
import script from "./CampusList.vue?vue&type=script&lang=js"
export * from "./CampusList.vue?vue&type=script&lang=js"
import style0 from "./CampusList.vue?vue&type=style&index=0&id=1b5cc294&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5cc294",
  null
  
)

export default component.exports